<template>
    <div class="front-form login" style="width: 360px;">
        <div class="front-form__wrap">
            <v-card class="front-form__block login__card">
                <v-toolbar dark color="primary" class="login__logotype">
                    <v-icon class="mr-3">$shieldHome</v-icon>
                    <v-toolbar-title>{{ $t('msg.loginAuth') }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-form>
                        <v-text-field
                            prepend-icon="$email"
                            data-vv-name="login"
                            :label="$t('msg.login')"
                            v-model="model.login"
                            v-validate="'required'"
                            :error-messages="errors.collect('login')"
                            @keyup.enter="onSubmit()"
                            outlined
                            dense
                            hide-details="auto"
                        ></v-text-field>
                        <v-text-field
                            prepend-icon="$lock"
                            data-vv-name="password"
                            :label="$t('msg.password')"
                            type="password"
                            v-model="model.password"
                            v-validate="'required'"
                            :error-messages="errors.collect('password')"
                            @keyup.enter="onSubmit()"
                            outlined
                            dense
                            hide-details="auto"
                            class="mt-4"
                        ></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        @click="onSubmit"
                        :disabled="loading"
                        :loading="loading"
                        small
                        class="mr-2 mb-3"
                    >{{ $t('msg.toLogin') }}</v-btn>
                </v-card-actions>
            </v-card>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            model: {
                login: null,
                password: null
            },
            loading: false
        }
    },
    methods: {
        onSubmit () {
            this.$validator.validateAll()
                .then(res => {
                    if (!res) return;

                    let foundUser = null;

                    this.$store.state.common.users.forEach(user => {

                        if (user.login === this.model.login && user.password === this.model.password) {
                            foundUser = user;
                        }
                    });

                    if (foundUser === null) {

                        this.errors.add({
                            field: 'password',
                            msg: this.$t('msg.invalidLoginOrPassword'),
                        })

                    } else {

                        this.$store.state.common.userId = foundUser.id;
                        this.$store.state.common.isLogin = true;

                        this.$router.push({name: 'video'});

                        localStorage.setItem('is_login_'+process.env.VUE_APP_VERSION, 'true');
                        localStorage.setItem('user_id_'+process.env.VUE_APP_VERSION, foundUser.id);
                    }
                });
        },
    },
}
</script>

<style lang="scss">
.login {
    max-width: calc(100vw - 28px);

    .login__card {
        overflow: hidden;
        border: 1px solid rgba(148, 163, 184, .22);
        border-radius: 20px !important;
        box-shadow: 0 24px 70px rgba(15, 23, 42, .16) !important;
    }
    .v-card__text {
        padding: 28px 28px 18px;
    }
    .v-card__actions {
        padding: 0 26px 24px;
    }
    .v-btn {
        min-width: 110px;
        height: 40px !important;
        border-radius: 10px;
        text-transform: none;
        letter-spacing: 0;
    }
}
.login__logotype {
    height: 76px !important;
    background: linear-gradient(135deg, #17212b 0%, #0f766e 100%) !important;

    .v-toolbar__content {
        display: flex;
        justify-content: center;
        height: 76px !important;
    }
}
</style>
